import setupResponseChart from './render_chart.js';

document.addEventListener('turbolinks:load', () => {
  const chartContainer = document.getElementById('incident-responses-chart');
  if(!chartContainer) return;

  setupResponseChart();
})
